<template>
  <vx-card title="Top Stressors">
    <vs-row v-if="extractedData" vs-align="center" vs-justify="center">
      <vs-col vs-w="12">
        <vue-apex-charts height="500" type="treemap" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>

export default {
  name: 'mental-health-stressors-card',
  props: {
    data: Object
  },
  data () {
    return {
      extractedData: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const topStressors = allTime.nested.find(n => n.name === 'MAIN_STRESSORS');

        const series = [];
        let total = 0;
        topStressors.buckets.forEach(topStressor => {
          total += topStressor.count;
          const serie = {
            name: topStressor.key,
            total: topStressor.count,
            data: []
          };
          if (!topStressor.nested || !topStressor.nested.find(n => n.name === 'DETAIL_STRESSORS') || !topStressor.nested.find(n => n.name === 'DETAIL_STRESSORS').buckets.length) {
            serie.data.push({
              x: '__all__',
              y: topStressor.count
            });
            return;
          }
          const detailStressors = topStressor.nested.find(n => n.name === 'DETAIL_STRESSORS');
          detailStressors.buckets.forEach(detailStressor => {
            serie.data.push({
              x: detailStressor.key,
              y: detailStressor.count
            });
          });

          series.push(serie);
        });

        this.extractedData = {
          total,
          series,
          chartOptions: {
            legend: {
              show: true
            },
            colors: [
              '#001f54',
              '#007526',
              '#ffd700',
              '#ff0000',
              '#2e0059',
              '#999999',
              '#5a1300',
              '#6495ed',
              '#ffdab9'
            ],
            dataLabels: {
              enabled: false
            },
            tooltip: {
              enabled: true,
              x: {
                show: true,
                formatter (val, other) {
                  return `${series[other.seriesIndex].name} (${(100 * (series[other.seriesIndex].total / total)).toFixed(1)}% of total)`;
                }
              },
              y: {
                formatter (val, other) {
                  return `${val} (${(100 * (val / series[other.seriesIndex].total)).toFixed(1)}% of ${series[other.seriesIndex].name})`;
                },
                title: {
                  formatter: (seriesName) => seriesName
                }
              }

            },
            chart: {

              toolbar: {
                show: false
              },
              height: 500,
              type: 'treemap'
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
